import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getLeagueList} from '../../../apis/league/getLeagueList'

const useQueryLeagueList = (currentPage: number = 1) => {
    const PAGE_SIZE = 10
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.league.getLeagueList(),
        queryFn: async () => {
            const {data, pageInfo} = await getLeagueList(PAGE_SIZE, currentPage)
            return {data, pageInfo}
        },
    })

    return {data: data?.data, pageInfo: data?.pageInfo, refetch}
}

export default useQueryLeagueList
